export const productosEmpresa = {
  producto1: {
    titulo: "Líneas de financiación",
    descripcion:
      "Te contamos todas las lineas a las que podés acceder con condiciones especiales. Financiá tu empresa con las mejores opciones de Préstamos a Tasa Especial, Descuento de Cheques, Adelanto de Cupones VISA; Tarjetas de Crédito o Descubierto en Cuenta Corriente. Tenemos la mejor opción para tu empresa."
  },
  producto2: {
    titulo: "Cobros y pagos",
    descripcion:
      "Gestioná la caja de tu empresa con las mejores herramientas digitales. Asesorate para conocer cómo operar con nuestras terminales de cobro, Botón de Pago digital; Pago de haberes con beneficios para vos y tus empleados y Pago Mis Cuentas."
  }
};

export const productosEmprendedor = {
  producto1: {
    titulo: "Líneas de financiación",
    descripcion:
      "Obtené financiación preferencial para tu emprendimiento o comercio, solo necesitás tener certificado Mipyme vigente."
  },
  producto2: {
    titulo: "Seguro integral de comercio",
    descripcion:
      "Te ofrecemos un seguro adaptado a las necesidades de tu negocio y una bonificación hasta el 40% en las primeras 3 cuotas."
  }
};
